import React, { useState, useEffect } from 'react';
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import styled from 'styled-components';
import '../../styles/CustomModal.css';
import 'moment/locale/ko';
import DetectorController, {
  DevicePathLogType,
  DeviceDetailType,
} from '../../controller/DetectorController';
import 'moment/locale/ko';
import moment from 'moment';
import DateTab from '../DateTab';
import Toggle from '../CustomToggle';

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
  pathLogData: DevicePathLogType[];
  openPathLog: any;
  userTokenId: number;
  deviceDetailData?: DeviceDetailType;
  refresh: any;
  roomName?: string;
};

type Params =
  | 'timer'
  | 'sector'
  | 'category'
  | 'product'
  | 'card'
  | 'voucher'
  | 'coupon'
  | 'adver'
  | 'concierge'
  | 'storeChat'
  | 'cs'
  | 'cart'
  | 'event'
  | 'navigate'
  | 'payment'
  | 'order'
  | 'morningCall'
  | 'arrival'
  | 'checkout'
  | 'cancel'
  | 'rating'
  | 'lang'
  | 'click'
  | 'guide'
  | 'error';

type ParamsType = {
  params: Params;
  path_url: string;
  title: string;
};

const ParamItems: ParamsType[] = [
  {
    params: 'timer',
    path_url: `${process.env.PUBLIC_URL}/svg/status_timer.svg`,
    title: '특정 시간 로직',
  },
  {
    params: 'sector',
    path_url: `${process.env.PUBLIC_URL}/svg/status_sector.svg`,
    title: '업종',
  },
  {
    params: 'category',
    path_url: `${process.env.PUBLIC_URL}/svg/status_menuCategory.svg`,
    title: '카테고리',
  },
  {
    params: 'product',
    path_url: `${process.env.PUBLIC_URL}/svg/status_menu.svg`,
    title: '상품',
  },
  {
    params: 'card',
    path_url: '',
    title: '호텔 소개',
  },
  {
    params: 'voucher',
    path_url: `${process.env.PUBLIC_URL}/svg/status_coupon.svg`,
    title: '주변 맛집',
  },
  {
    params: 'coupon',
    path_url: `${process.env.PUBLIC_URL}/svg/status_coupon.svg`,
    title: '쿠폰',
  },
  {
    params: 'adver',
    path_url: `${process.env.PUBLIC_URL}/svg/status_coupon.svg`,
    title: '광고',
  },
  {
    params: 'concierge',
    path_url: `${process.env.PUBLIC_URL}/svg/status_concierge.svg`,
    title: '프론트요청',
  },
  {
    params: 'storeChat',
    path_url: `${process.env.PUBLIC_URL}/svg/status_store.svg`,
    title: '매장 채팅',
  },
  {
    params: 'cs',
    path_url: `${process.env.PUBLIC_URL}/svg/status_cs.svg`,
    title: '노크노크 긴급요청',
  },
  {
    params: 'cart',
    path_url: `${process.env.PUBLIC_URL}/svg/status_cart.svg`,
    title: '장바구니 변동',
  },
  {
    params: 'event',
    path_url: `${process.env.PUBLIC_URL}/svg/status_event.svg`,
    title: '이벤트',
  },
  {
    params: 'navigate',
    path_url: `${process.env.PUBLIC_URL}/svg/status_move_path.svg`,
    title: '페이지 이동',
  },
  {
    params: 'payment',
    path_url: `${process.env.PUBLIC_URL}/svg/status_payment.svg`,
    title: '결제',
  },
  {
    params: 'order',
    path_url: `${process.env.PUBLIC_URL}/svg/status_order.svg`,
    title: '주문',
  },
  {
    params: 'morningCall',
    path_url: '',
    title: '모닝콜',
  },
  {
    params: 'arrival',
    path_url: '',
    title: '주문 도착',
  },
  {
    params: 'checkout',
    path_url: `${process.env.PUBLIC_URL}/svg/ic_calendar.svg`,
    title: '체크아웃',
  },
  {
    params: 'cancel',
    path_url: `${process.env.PUBLIC_URL}/svg/status_cancel_payment.svg`,
    title: '주문 취소',
  },
  {
    params: 'rating',
    path_url: `${process.env.PUBLIC_URL}/svg/status_rating.svg`,
    title: '리뷰',
  },
  {
    params: 'lang',
    path_url: `${process.env.PUBLIC_URL}/svg/status_language.svg`,
    title: '언어 설정',
  },
  {
    params: 'click',
    path_url: `${process.env.PUBLIC_URL}/svg/status_click.svg`,
    title: '버튼 클릭',
  },
  {
    params: 'guide',
    path_url: `${process.env.PUBLIC_URL}/svg/ic_edit.svg`,
    title: '노크노크 가이드',
  },
  {
    params: 'error',
    path_url: `${process.env.PUBLIC_URL}/svg/status_error.svg`,
    title: '연결 불량',
  },
];

const PeriodDetailModal = ({
  isVisible,
  setVisible,
  pathLogData,
  openPathLog,
  userTokenId,
  deviceDetailData,
  refresh,
  roomName,
}: Props) => {
  const [powerItem, setPowerItem] = useState<number>(0);
  const [wifiItem, setWifiItem] = useState<number>(0);
  const [isMemo, setIsMemo] = useState<string>('');
  const [isEditing, setIsEditing] = useState<boolean>(false);

  const onCloseModal = () => {
    setVisible(false);
  };
  const openPathLogUsertokenId = (startDate: Date, endDate: Date) => {
    openPathLog(userTokenId, startDate, endDate);
  };
  const onTogglePower = (selected: boolean) => {
    const newPowerItem = selected ? 0 : 1;
    setPowerItem(newPowerItem);
  };

  const onToggleWifi = (selected: boolean) => {
    const newWifiItem = selected ? 0 : 1;
    setWifiItem(newWifiItem);
  };
  const toggleEditMode = () => {
    setIsEditing((prev) => !prev);
  };

  // 현재 페이지
  const getStatusComment = (params: Params) => {
    const paramState = ParamItems.find((item) => item.params === params);

    return (
      paramState && (
        <div className="row">
          {paramState.path_url.length > 0 && (
            <img src={paramState.path_url} alt="장바구니 변동" width={16} />
          )}
          <p>{paramState.title}</p>
        </div>
      )
    );
  };

  const setUserTokenInfo = async () => {
    try {
      const oData = {
        user_token_id: userTokenId,
        data: {
          device_power: powerItem,
          device_memo: isMemo,
          device_wifi_power: wifiItem,
        },
      };
      const response = await DetectorController.setUserTokenInfo(oData);
      if (response && response.data) {
        refresh();
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  const memoButton = () => {
    toggleEditMode();
    if (isEditing) {
      setUserTokenInfo();
    }
  };

  useEffect(() => {
    if (deviceDetailData) {
      setPowerItem(deviceDetailData.device_power === 1 ? 1 : 0);
      setWifiItem(deviceDetailData.device_wifi_power === 1 ? 1 : 0);
      setIsMemo(deviceDetailData?.device_memo);
    }
  }, [deviceDetailData, isVisible]);
  useEffect(() => {
    setIsEditing(false);
  }, [isVisible]);

  return (
    <Style>
      {isVisible && (
        <div className="modalWrap">
          <div className="modalBackground" onClick={onCloseModal}></div>
          <div className="modal">
            <div className="content">
              <img
                src={`${process.env.PUBLIC_URL}/svg/ic_close.svg`}
                alt="닫기"
                width={28}
                className="modalCloseButton"
                onClick={onCloseModal}
              />
              <div>
                <p>
                  {roomName}(user_token_id: {userTokenId})
                </p>

                <div className={` memoWrap ${!isEditing && 'disabled'}`}>
                  <div className="memoTitle">
                    <h3>객실 세부 설정</h3>
                    <button onClick={memoButton}>{isEditing ? '저장' : '수정'}</button>
                  </div>
                  <div>
                    <div className="toggleWrap">
                      <Toggle
                        toggleItem={powerItem === 0}
                        toggleFirstTitle={'전원 상시'}
                        toggleSecondTitle={'전원 비상시'}
                        onChange={onTogglePower}
                        disabled={!isEditing}
                      />
                      <Toggle
                        toggleItem={wifiItem === 0}
                        toggleFirstTitle={'인터넷 상시'}
                        toggleSecondTitle={'인터넷 비상시'}
                        onChange={onToggleWifi}
                        disabled={!isEditing}
                      />
                    </div>
                    <textarea
                      className="memoContent"
                      id="memoContent"
                      value={isMemo}
                      readOnly={!isEditing}
                      onChange={(e) => setIsMemo(e.target.value)}
                      placeholder="메모를 입력해주세요."></textarea>
                  </div>
                </div>
              </div>
              <DateTab type="oneDay" openPathLog={openPathLogUsertokenId} />

              <div className="title">
                <h2 className="date">날짜</h2>
                <h2 className="action">클릭</h2>
                <h2 className="detail">상세내역</h2>
              </div>
              <div className="contentWrap">
                {pathLogData && pathLogData.length > 0 ? (
                  pathLogData.map((data, index) => {
                    return (
                      <div className="modalContent" key={index}>
                        <p className="date">
                          {moment(data.created_at).format('YYYY/MM/DD HH:mm:ss')}
                        </p>
                        <p className="room">{data.name}</p>
                        <p className="action">{getStatusComment(data.params)}</p>
                        <p className="detail">{data.params2}</p>
                      </div>
                    );
                  })
                ) : (
                  <h2 className="noneList">클릭 내역 없음</h2>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </Style>
  );
};

export default PeriodDetailModal;

const Style = styled.div`
  h2 {
    font-size: 16px !important;
    font-weight: 500;
  }
  p {
    margin: 10px 0;
    font-size: 12px;
  }

  .content {
    width: 70%;
    padding: 2%;
    z-index: 9999;
    text-align: left;
    background: #fff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    position: relative;
  }
  .modalCloseButton {
    position: absolute;
    top: 3%;
    right: 2%;
    cursor: pointer;
  }

  .row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }
  .title,
  .modalContent {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .title {
    margin-top: 24px;
    padding-bottom: 12px;
    border-bottom: 1px solid #ddd;
  }
  .contentWrap {
    min-height: 30vh;
    max-height: 50vh;
    overflow-y: auto;
  }
  .modalContent {
    border-bottom: 1px solid #eee;
  }

  .date {
    flex: 0 0 20%;
  }
  .room {
    flex: 0 0 10%;
    text-align: center;
  }
  .action {
    flex: 0 0 30%;
    text-align: center;
  }
  .detail {
    flex: 0 0 40%;
    white-space: pre-line;
  }
  .noneList {
    margin: 50px 0;
  }

  /* 객실 세부 설정 */
  .toggleWrap {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .memoWrap {
    margin-bottom: 20px;
    padding: 12px;
    background: #f6f6f6;
    border: 1px solid #eee;
    border-radius: 4px;
    height: 130px;
  }
  .memoWrap.disabled {
    background: #ccc;

    textarea {
      background: #ccc;
      border: 1px solid #bbb;
      outline: none;
      cursor: not-allowed;
    }
    .toggleWrap button {
      cursor: not-allowed;
    }
  }
  .memoTitle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 4px;
    border-bottom: 1px solid #ccc;

    h3 {
      color: #777;
    }
    button {
      background: #000;
      color: #fff;
      border: none;
      padding: 2px 10px;
      font-size: 14px;
      line-height: 20px;
      border-radius: 4px;
      font-weight: 500;
    }
  }
  .memoContent {
    width: 100%;
    max-width: 100%;
    height: 75%;
    padding: 4px 6px;
    margin-top: 4px;
    word-break: break-word;
    font-size: 14px;
    line-height: 18px;
    border: none;
    border-radius: 4px;
  }

  /* 스크롤바 */
  .contentWrap::-webkit-scrollbar {
    width: 4px;
    background-color: #d1d1d1;
    border-radius: 50px;
  }
  .contentWrap::-webkit-scrollbar-thumb {
    width: 4px;
    background-color: #000;
    border-radius: 50px;
  }

  @media (max-width: 900px) {
    .content {
      width: 90%;
      padding: 4%;
    }
  }
  @media (max-width: 500px) {
    .memoWrap {
      height: 160px;
    }
    .toggleWrap {
      flex-direction: column;
      gap: 0;
      justify-content: flex-start;
      align-items: flex-start;
    }
  }
`;
